import React, { useState } from "react";
import "./launch-pages.css";
export default function PasswordRecovery({
  token = "",
  reset = Boolean(token),
}) {
  const [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [error, setError] = useState("");
  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setError("");
    if (reset && password !== confirmation) {
      setError("Les deux mots de passe doivent être identiques.");
      return;
    }
    setBusy(true);
    const controller = new AbortController(),
      timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(
        "https://api.brainteaserday.com/api/auth/" +
          (reset ? "reset-password" : "forgot-password"),
        {
          method: "POST",
          signal: controller.signal,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reset ? { token, password } : { email }),
        },
      );
      const data = await response.json();
      if (!response.ok)
        throw Error(data.error || "Demande impossible. Réessaie.");
      setMessage(data.message);
      if (reset) {
        localStorage.removeItem("auth_token");
        setPassword("");
        setConfirmation("");
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search,
        );
      }
    } catch (e) {
      setError(
        e.name === "AbortError"
          ? "La connexion est trop lente. Réessaie."
          : e.message === "Failed to fetch"
            ? "Connexion impossible. Vérifie ta connexion et réessaie."
            : e.message,
      );
    } finally {
      clearTimeout(timer);
      setBusy(false);
    }
  }
  return (
    <main className="info-page">
      <a href="#connexion">← Retour à la connexion</a>
      <h1>{reset ? "Un nouveau départ." : "Mot de passe oublié ?"}</h1>
      <p className="info-lead">
        {reset
          ? "Choisis un nouveau mot de passe pour retrouver tes défis."
          : "Entre l’adresse e-mail de ton compte. Tu recevras un lien pour choisir un nouveau mot de passe."}
      </p>
      <section className="card">
        {reset && !/^[a-f0-9]{64}$/.test(token) ? (
          <div role="alert">
            <p>Ce lien est incomplet ou invalide.</p>
            <a href="#mot-de-passe-oublie">Demander un nouveau lien</a>
          </div>
        ) : message ? (
          <div className="recovery-status" role="status">
            <p>{message}</p>
            {reset ? (
              <a className="btn btn-primary" href="#connexion">
                Me connecter
              </a>
            ) : (
              <p>
                Le lien est valable 30 minutes. Si aucun message n’arrive,
                vérifie l’adresse et les spams, puis{" "}
                <button className="btn" onClick={() => setMessage("")}>
                  Réessayer
                </button>
                .
              </p>
            )}
          </div>
        ) : (
          <form className="recovery-form" onSubmit={submit}>
            {reset ? (
              <>
                <label htmlFor="new-password">Nouveau mot de passe</label>
                <input
                  id="new-password"
                  className="input"
                  type="password"
                  autoComplete="new-password"
                  minLength={8}
                  maxLength={72}
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <p className="recovery-hint">
                  Au moins 8 caractères. Une phrase longue et unique est un bon
                  choix.
                </p>
                <label htmlFor="confirm-password">
                  Confirmer le mot de passe
                </label>
                <input
                  id="confirm-password"
                  className="input"
                  type="password"
                  autoComplete="new-password"
                  minLength={8}
                  maxLength={72}
                  required
                  value={confirmation}
                  onChange={(e) => setConfirmation(e.target.value)}
                />
              </>
            ) : (
              <>
                <label htmlFor="recovery-email">Adresse e-mail</label>
                <input
                  id="recovery-email"
                  className="input"
                  type="email"
                  autoComplete="email"
                  maxLength={254}
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </>
            )}
            {error && <p role="alert">{error}</p>}
            <button className="btn btn-primary" disabled={busy}>
              {busy
                ? "Un instant…"
                : reset
                  ? "Enregistrer mon mot de passe"
                  : "Recevoir le lien"}
            </button>
            {reset && (
              <p>
                <a href="#mot-de-passe-oublie">
                  Lien expiré ? En demander un autre
                </a>
              </p>
            )}
          </form>
        )}
      </section>
      <p className="recovery-hint">
        Besoin d’aide ? <a href="#contact">Contacter Valentin</a>.{" "}
        <a href="#confidentialite">Confidentialité</a>.
      </p>
    </main>
  );
}
